// Page ouverte depuis un lien d'invitation (ami ou coach) : tente d'ouvrir
// l'app avec le code, et l'affiche pour le saisir à la main sinon.
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Tiggy from "../site/Tiggy";
import BoutonsStores from "../site/BoutonsStores";

function Invite() {
	const [searchParams] = useSearchParams();

	// Anciens liens : un # dans le code coupe l'URL
	// (ex. /invite?code=#7e6b5b61-...# : le paramètre est vide, la suite passe dans le hash).
	const rawCode = searchParams.get("code");
	const hash = window.location.hash;
	const code = rawCode || (hash ? "#" + hash.replace(/^#/, "") : null);

	useEffect(() => {
		if (!code) return;
		// Ouvre l'app par lien profond ; si elle ne s'ouvre pas, la page reste
		// affichée avec le code et les liens des stores.
		window.location.href = `gymnote://invite?code=${encodeURIComponent(code)}`;
	}, [code]);

	return (
		<section className="gs-page">
			<div className="gs-quadrillage gs-quadrillage--page" />
			<div className="gs-conteneur">
				<div className="gs-carte gs-page-carte">
					{code ? (
						<>
							<Tiggy pose="pouce_leve" taille={150} />
							<h1 className="gs-page-titre">Tu es invité sur GymNote</h1>
							<p className="gs-texte">
								Si l'application ne s'ouvre pas toute seule, ouvre GymNote et saisis ce code :
							</p>
							<div className="gs-champ gs-champ-code" style={{ width: "100%" }}>
								<input readOnly value={code} aria-label="Code d'invitation" onFocus={(e) => e.target.select()} />
							</div>
							<p className="gs-texte-petit">Pas encore l'app ? Télécharge-la d'abord :</p>
							<BoutonsStores />
						</>
					) : (
						<>
							<Tiggy pose="reflexion" taille={150} />
							<h1 className="gs-page-titre">Lien invalide</h1>
							<p className="gs-texte">Ce lien d'invitation n'est pas valide. Demande un nouveau code à la personne qui t'a invité.</p>
						</>
					)}
				</div>
			</div>
		</section>
	);
}

export default Invite;
